import { BaseButton } from '../BaseButton/BaseButton';

export const BaseButtonFill = (props) => {
  const { children, ...rest } = props;

  return (
    <BaseButton fill {...rest}>
      {children}
    </BaseButton>
  );
};

export default BaseButtonFill;
